import type { ReactNode } from 'react';
import { periodLabel, type Period } from './period';
import type { ChartSeries } from './period-chart-geometry';

export interface PeriodChartTableProps {
  caption: string;
  buckets: readonly Period[];
  series: readonly ChartSeries[];
  previous?: { label: string; values: readonly number[] } | undefined;
  /** Shown on the page; otherwise it is there for a screen reader only. */
  shown: boolean;
}

/** The chart's numbers as a real table: one row a bucket, one column a series, the same formats. */
export function PeriodChartTable(props: PeriodChartTableProps): ReactNode {
  const { buckets, series, previous } = props;
  const format = series[0]?.format ?? String;
  return (
    <div className={props.shown ? 'ad-pchart__table' : 'pui-visually-hidden'}>
      <table className="ad-sort">
        <caption className="pui-visually-hidden">{props.caption}</caption>
        <thead>
          <tr>
            <th scope="col">Days</th>
            {series.map((s) => (
              <th key={s.key} scope="col" className="is-numeric">
                {s.label}
              </th>
            ))}
            {previous ? (
              <th scope="col" className="is-numeric">
                {previous.label}
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {buckets.map((bucket, i) => (
            <tr key={bucket.from}>
              <th scope="row">{periodLabel(bucket)}</th>
              {series.map((s) => (
                <td key={s.key} className="is-numeric">
                  {s.format(s.values[i] ?? 0)}
                </td>
              ))}
              {previous ? <td className="is-numeric">{format(previous.values[i] ?? 0)}</td> : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
